import { Table, TableBody, TableCell, TableContainer, TableRow } from '@mui/material';
import { ITheme } from '../../utils/theme';
import { tableSubCellStyle } from '../current-dispatch/styled';
import { SlipDetails } from './DispatchSlipData';
import { CheckBoxField } from './DispatchSlipDetails';
import { iconStyle, tableCellStyle } from './styled';

const bottomCheckboxFields: CheckBoxField[] = [
  { field: 'isDirtyCargo', title: 'Dirty Cargo' },
  { field: 'isFreezer', title: 'Freezer' },
  { field: 'isHides', title: 'Hides' },
  { field: 'isOffensive', title: 'Offensive' },
]

export const DispatchSlipFooter = ({
  slipDetails,
}:
  { slipDetails: SlipDetails }
) => {
  const cellStyle = (theme: ITheme) => tableCellStyle(theme, slipDetails.slipColour);
  return (
    <TableContainer>
      <Table size="custom" cellSpacing={0} cellPadding={0} width={470} sx={{ bgcolor: 'slipTableBackgroundColor' }} border={0}>
        <TableBody>
          <TableRow>
            <TableCell sx={{ padding: 0 }}>
              <Table>
                <TableBody>
                  <TableRow>
                    <TableCell sx={cellStyle} align="center">
                      {slipDetails.defaultWarnings}
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell sx={cellStyle} valign="middle" align="center">
                      <Table width="100%" border={0} cellPadding={0} cellSpacing={0}>
                        <TableBody>
                          <TableRow>
                            {
                              bottomCheckboxFields.map(({ title, field }) => (
                                <TableCell key={title} sx={tableSubCellStyle} valign="middle">
                                  {title}
                                  <img
                                    src={`/assets/images/slip_box${slipDetails[field] ? '_checked' : ''}.gif`}
                                    alt={title}
                                    style={iconStyle}
                                  />
                                </TableCell>
                              ))
                            }
                          </TableRow>
                        </TableBody>
                      </Table>
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell sx={cellStyle} colSpan={3} align="center">
                      &nbsp;
                    </TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </TableContainer>
  );
}